export default __webpack_public_path__ + "partner_169024f0.png";